/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Dialog, makeStyles, Typography } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DuplicateTable from './DuplicateTable';
import ImportStrategyForm from './ImportStrategyForm';
import Button from '../../common/Button';
import AlertDialog from '../../common/alertDialog/AlertDialog';
import useDuplicateContactDialog from './useDuplicateContactDialog';
import { PartyStatus } from '../PartyStatus';

const useStyles = makeStyles(theme => ({
  duplicatesFound: {
    fontWeight: theme.typography.fontWeightBold,
    margin: '1rem 2rem',
  },
  tableWrapper: {
    margin: '0rem 2rem 1rem',
  },
  importFormWrapper: {
    margin: '1rem 2rem',
  },
}));

export default function DuplicateContactDialog(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { partyResult, onAllDuplicatesResolved, onCancelSave } = props;
  const {
    strategy,
    applyToAll,
    currentDuplicate,
    onStrategyChange,
    onApplyToAllChange,
    onImport,
    onCancel,
    showCancelConfirm,
    setShowCancelConfirm,
  } = useDuplicateContactDialog(partyResult, onAllDuplicatesResolved, onCancelSave);

  return (
    <Dialog open={partyResult.status === PartyStatus.DUPLICATED} fullWidth maxWidth="md">
      <DialogTitle variant="h2" component="h2">
        <Typography component="span" variant="h2">
          {t('add.contact')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {t('messages.contact.one.existing')} 
        {' '}
        {t('messages.contact.compare')}
        <div className={classes.duplicatesFound}>{t('messages.contact.one.duplicate')}</div>
        {currentDuplicate && (
          <div className={classes.tableWrapper}>
            <DuplicateTable duplicate={currentDuplicate} />
          </div>
        )}
        <div className={classes.importFormWrapper}>
          <ImportStrategyForm
            strategy={strategy}
            applyToAll={applyToAll}
            onStrategyChange={onStrategyChange}
            onApplyToAllChange={onApplyToAllChange}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => setShowCancelConfirm(true)}>
          {t('actions.cancel')}
        </Button>
        <Button color="primary" disabled={!strategy} onClick={onImport}>
          {t('save.changes')}
        </Button>
      </DialogActions>
      <AlertDialog
        isOpen={!!showCancelConfirm}
        title="messages.are-you-sure"
        message="messages.confirmation.cancel.addition"
        confirmButtonMessage="actions.import.cancel"
        handleConfirmButton={onCancel}
        showCancelButton={true}
        cancelButtonMessage="actions.import.continue"
        handleCancelButton={() => setShowCancelConfirm(false)}
      />
    </Dialog>
  );
}
